import { StoreActionType as Type } from '../../types';
export const setCurrentUser: any =
    (dispatch: any) =>
    (action: any): any => {
        return new Promise((resolve: any): any => {
            dispatch({
                type: Type.SET_CURRENT_USER,
                info: { ...action },
            });
            resolve();
        });
    };
